<template>
  <div class="information">
    <div class="contentRight2">
      <div class="contentTabs" style>
        <!-- 顶部tab栏 -->
        <el-tabs v-model="activeName">
          <el-tab-pane label="经营数据" name="first">
            <div class="first">
              <div class="head row">
                <h5>交易概况</h5>
                <span style="margin-left:10px;">更新时间：{{getTime}}</span>
              </div>
              <div class="content">
                <div class="details column">
                  <div class="text1">总营业额</div>
                  <div class="text2">{{toDay.totalRetailPrice}}</div>
                  <!-- <div class="text3">昨日：30.02</div> -->
                </div>
                <div class="details column">
                  <div class="text1">实收金额(总营业额-退款-优惠)</div>
                  <div class="text2">{{toDay.money}}</div>
                  <!-- <div class="text3">前一天：6.00</div> -->
                </div>
                <div class="details column">
                  <div class="text1">退款金额</div>
                  <div class="text2">{{toDay.refundMoney}}</div>
                  <!-- <div class="text3">前一天：6.00</div> -->
                </div>
                <div class="details column">
                  <div class="text1">优惠金额</div>
                  <div class="text2">{{toDay.totalDiscountPrice}}</div>
                  <!-- <div class="text3">前一天：6.00</div> -->
                </div>
                <div class="details column">
                  <div class="text1">支付订单数(笔)</div>
                  <div class="text2">{{toDay.orderNum}}</div>
                  <!-- <div class="text3">前一天：6.00</div> -->
                </div>
                <div class="details column">
                  <div class="text1">客单价(实收/支付订单数)</div>
                  <div class="text2">{{toDay.customerMoney}}</div>
                  <!-- <div class="text3">前一天：6.00</div> -->
                </div>

              </div>
              <!-- 交易趋势 -->
              <div class="topPlate">
                <div
                  class="bottomTitle row alignCenter"
                  style="display:flex;justify-content: space-between;"
                >
                  <h5>交易趋势</h5>
                  <div class="row alignCenter">
                    <div class="block">
                      <el-radio-group v-model="timeTabs" size="mini">
                        <el-radio-button
                          v-for="item in pickerOptions1.shortcuts"
                          :key="item.text"
                          :label="item.value"
                          >{{ item.text }}</el-radio-button
                        >
                      </el-radio-group>
                    </div>
                    <div class="totot"></div>
                    <el-select
                      size="small"
                      @change="shopChange()"
                      v-model="value"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in shopList"
                        :key="item.storeName"
                        :label="item.storeName"
                        :value="item.shopStoreId"
                      ></el-option>
                    </el-select>
                    <div class="totot"></div>
                    <div class="block">
                      <!-- <el-date-picker
                        v-model="value5"
                        type="datetimerange"
                        format="yyyy-MM-dd"
                        unlink-panels
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="dateChange('threeMonth')"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions2"
                      ></el-date-picker> -->
                      <el-date-picker
                        size="small"
                        v-model="value5"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions5"
                        @change="dateChange('threeMonth')"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div style="margin-top:20px;margin-left:10px;">
                  <div class="row">
                    <div @click="tep1" :class="checked?'tep':'tep2'">
                      <div class="tepTitle">
                        交易金额（元）
                        <!-- <el-checkbox v-model="checked"></el-checkbox> -->
                        <div class="center" style="cursor: pointer">
                          <img v-if="!checked" src="../../assets/icon/wx.png" alt />
                          <img v-if="checked" src="../../assets/icon/qx.png" alt />
                        </div>
                      </div>
                      <h3 class="tepPrice">{{ShopStoreStatistic.money}}</h3>
                      <div class="tepText row">
                        <div>较前一日</div>
                        <div
                          v-if="ShopStoreStatistic.orderNumDayPercent"
                        >{{ShopStoreStatistic.moneyDayPercent}}%</div>

                        <div v-else>无</div>
                      </div>
                      <div class="tepText row">
                        <div>较上周同期</div>
                        <div
                          v-if="ShopStoreStatistic.orderNumWeekPercent"
                        >{{ShopStoreStatistic.moneyWeekPercent}}%</div>
                        <div v-else>无</div>
                      </div>
                    </div>
                    <div @click="tep2" :class="checked2?'tep':'tep2'">
                      <div class="tepTitle">
                        新增会员数
                        <!-- <el-checkbox v-model="checked2"></el-checkbox> -->
                        <div class="center" style="cursor: pointer">
                          <img v-if="!checked2" src="../../assets/icon/wx.png" alt />
                          <img v-if="checked2" src="../../assets/icon/qx.png" alt />
                        </div>
                      </div>
                      <h3 class="tepPrice">{{ShopStoreStatistic.newShopMemberNum}}</h3>
                      <div class="tepText row">
                        <div>较前一日</div>
                        <div
                          v-if="ShopStoreStatistic.newShopMemberNumDayPercent"
                        >{{ShopStoreStatistic.newShopMemberNumDayPercent}}%-</div>
                        <div v-else>无</div>
                      </div>
                      <div class="tepText row">
                        <div>较上周同期</div>
                        <div
                          v-if="ShopStoreStatistic.newShopMemberNumWeekPercent"
                        >{{ShopStoreStatistic.newShopMemberNumWeekPercent}}%-</div>
                        <div v-else>无</div>
                      </div>
                    </div>
                    <div @click="tep3" :class="checked3?'tep':'tep2'">
                      <div class="tepTitle">
                        增加订单数
                        <!-- <el-checkbox v-model="checked3"></el-checkbox> -->
                        <div class="center" style="cursor: pointer">
                          <img v-if="!checked3" src="../../assets/icon/wx.png" alt />
                          <img v-if="checked3" src="../../assets/icon/qx.png" alt />
                        </div>
                      </div>
                      <h3 class="tepPrice">{{ShopStoreStatistic.orderNum}}</h3>
                      <div class="tepText row">
                        <div>较前一日</div>
                        <div
                          v-if="ShopStoreStatistic.moneyDayPercent"
                        >{{ShopStoreStatistic.orderNumDayPercent}}%</div>
                        <div v-else>无</div>
                      </div>
                      <div class="tepText row">
                        <div>较上周同期</div>
                        <div
                          v-if="ShopStoreStatistic.moneyWeekPercent"
                        >{{ShopStoreStatistic.orderNumWeekPercent}}%</div>
                        <div v-else>无</div>
                      </div>
                    </div>
                  </div>
                  <!-- 映射文字 -->
                  <div class="row">
                    <div v-if="checked" class="map row alignCenter">
                      <div class="circle"></div>
                      <div class="mapText">交易金额</div>
                    </div>
                    <div v-if="checked2" class="map row alignCenter">
                      <div class="circle1"></div>
                      <div class="mapText">新增会员数</div>
                    </div>
                    <div v-if="checked3" class="map row alignCenter">
                      <div class="circle2"></div>
                      <div class="mapText">增加订单数</div>
                    </div>
                  </div>
                  <!-- 统计图 -->
                  <div :id="id" style="width:calc(100vw - 200px);height:260px;left:0"></div>
                </div>
              </div>
              <div class="bottomTitle row alignCenter flex-between">
                <h5>销售统计</h5>
                <el-select size="small" v-model="selectJob" placeholder="请选择">
                  <el-option
                    v-for="item in jobList"
                    :key="item.jobName"
                    :label="item.jobName"
                    :value="item.jobName"
                  ></el-option>
                </el-select>
              </div>
              <!-- 销售员表格 -->
              <div v-if="selectJob == '销售员'">
                <div style="margin-top:20px;">
                  <el-table :data="saleList" style="width: 100%" align="center">
                    <!-- <el-table-column label="商品名称" width="180">
                      <template slot-scope="scope">{{scope.row.goodsName}}</template>
                    </el-table-column>-->
                    <el-table-column
                      align="center"
                      prop="cashierUserFullName"
                      label="销售员名称"
                      width="180"
                    ></el-table-column>
                    <el-table-column align="center" prop="money" label="销售金额"></el-table-column>
                    <el-table-column align="right" prop="orderNum" label="笔数"></el-table-column>
                  </el-table>
                </div>
                <div class="block" style="float:right;margin-top:10px;">
                  <!-- 分页 -->
                  <el-pagination
                    @current-change="saleHandleCurrentChange"
                    :current-page="1"
                    :page-size="3"
                    layout="total, prev, pager, next, jumper"
                    :total="saleTotalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- 收银员表格 -->
              <div v-if="selectJob == '收银员'">
                <div style="margin-top:20px;">
                  <el-table :data="cashierList" style="width: 100%" align="center">
                    <!-- <el-table-column label="商品名称" width="180">
                      <template slot-scope="scope">{{scope.row.goodsName}}</template>
                    </el-table-column>-->
                    <el-table-column
                      align="center"
                      prop="cashierUserFullName"
                      label="收银员名称"
                      width="180"
                    ></el-table-column>
                    <el-table-column align="center" prop="money" label="销售金额"></el-table-column>
                    <el-table-column align="right" prop="orderNum" label="笔数"></el-table-column>
                  </el-table>
                </div>
                <div class="block" style="float:right;margin-top:10px;">
                  <!-- 分页 -->
                  <el-pagination
                    @current-change="cashierHandleCurrentChange"
                    :current-page="1"
                    :page-size="3"
                    layout="total, prev, pager, next, jumper"
                    :total="cashierTotalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane id="fenye" label="商品分析" name="second">
            <div class="first">
              <div class="head row flex-between">
                <div class="row">
                  <h5>商品概况</h5>
                  <!-- <span style="margin-left:10px;">更新时间：{{getTime}}</span> -->
                </div>
                <div style="padding-right:10px" class="row alignCenter">
                  <el-select
                    size="small"
                    @change="shopChange()"
                    v-model="valueTwo"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in shopList"
                      :key="item.storeName"
                      :label="item.storeName"
                      :value="item.shopStoreId"
                    ></el-option>
                  </el-select>
                  <div class="totot"></div>
                  <el-select
                    size="small"
                    @change="shopChange()"
                    v-model="valueTwo2"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <div class="totot"></div>
                  <div class="block" v-show="this.valueTwo2 == '季度'">
                    <el-date-picker
                      v-model="valueTwo5"
                      type="monthrange"
                      unlink-panels
                      size="small"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="dateChange2('threeMonth')"
                      value-format="yyyy-MM"
                      :picker-options="pickerOptions2"
                    ></el-date-picker>
                  </div>

                  <div class="block" v-show="this.valueTwo2 == '周'">
                    <el-date-picker
                      v-model="valueTwo3"
                      type="daterange"
                      unlink-panels
                      size="small"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="dateChange2('week')"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </div>
                  <div class="block" v-if="this.valueTwo2 == '月'">
                    <div class="block">
                      <el-date-picker
                        @change="dateChange2('month')"
                        value-format="yyyy-MM"
                        v-model="valueTwo4"
                        type="month"
                        size="small"
                        placeholder="选择月"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="block" v-if="this.valueTwo2 == '日'">
                    <el-date-picker
                      value-format="yyyy-MM-dd"
                      v-model="valueTwo1"
                      type="date"
                      @change="dateChange2('date')"
                      size="small"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="details column">
                  <div class="text1">商品总销量（件）</div>
                  <div class="text2">{{todayGoods.productNum}}<span style="color:gray;font-size:14px;margin-left:5px">/{{todayGoods.orderNum}}笔</span></div>
                  <div class="text3">
                    较前一日：
                    <span style="color:red">{{todayGoods.productNumDayPercent}}%</span>
                  </div>
                  <div class="text3">
                    较上周同期：
                    <span style="color:red">{{todayGoods.productNumWeekPercent}}%</span>
                  </div>
                </div>
                <div class="details column">
                  <div class="text1">支付总金额（元）</div>
                  <div class="text2">{{todayGoods.productMoney}}</div>
                  <div class="text3">
                    较前一日：
                    <span style="color:green">{{todayGoods.moneyDayPercent}}%</span>
                  </div>
                  <div class="text3">
                    较上周同期：
                    <span style="color:green">{{todayGoods.moneyWeekPercent}}%</span>
                  </div>
                </div>
                <div class="details column">
                  <div class="text1">退款金额（元）</div>
                  <div class="text2" v-if="todayGoods.productRefundMoney">{{todayGoods.productRefundMoney.toFixed(2)}}<span style="color:gray;font-size:14px;margin-left:5px">/{{todayGoods.refundNum}}笔</span></div>
                  <div class="text3">
                    较前一日：
                    <span style="color:green">{{todayGoods.refundMoneyPercent}}%</span>
                  </div>
                  <div class="text3">
                    较上周同期：
                    <span style="color:green">{{todayGoods.refundMoneyPercent}}%</span>
                  </div>
                </div>
              </div>
              <!-- 交易趋势 -->
              <div class="topPlate">
                <div
                  class="bottomTitle row alignCenter"
                  style="display:flex;justify-content: space-between;"
                >
                  <h5>商品销售</h5>

                </div>

                <!-- 表格 -->

                <div style="margin-top:20px;">
                  <el-table :data="tableData" style="width: 100%" align="center">
                    <el-table-column label="商品名称" width="180">
                      <template slot-scope="scope">{{scope.row.goodsName}}</template>
                    </el-table-column>
                    <el-table-column align="center" prop="specDesc" label="商品规格" width="180"></el-table-column>
                    <el-table-column align="center" prop="qrcBuyCount" label="售出数量" width="180"></el-table-column>
                    <el-table-column align="center" prop="refundCount" label="退货数量"></el-table-column>
                    <el-table-column align="center" prop="totalTurnoverPrice" label="销售金额">
                       <template slot-scope="scope">
                        <span>￥{{scope.row.totalRetailPrice}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="总计">
                      <template slot-scope="scope">
                        <!-- <span v-if="scope.row.isInfiniteStock == 1">无限库存</span>
                        <span v-if="scope.row.isInfiniteStock == 0">{{scope.row.totalStockCount}}</span> -->
                        <span>￥{{(scope.row.totalTurnoverPrice - scope.row.refundMoney).toFixed(2)}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="block" style="float:right;margin-top:10px;">
                  <!-- 分页 -->
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="1"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane id="fenye" label="会员统计" name="third">
            <div class="first">
              <div class="head row">
                <h5>会员充值消费统计</h5>
                <!-- <span style="margin-left:10px;">更新时间：{{getTime}}</span> -->
              </div>
              <div class="content2">
                <div class="details2 column center">
                  <div class="text1">今日充值（元）</div>
                  <div class="text2 red">{{vipList.vipDate.today_total_recharge}}</div>
                </div>
                <div class="details2 column center">
                  <div class="text1">线上充值（元）</div>
                  <div class="text2">{{vipList.vipDate.today_online_recharge}}</div>
                </div>
                <div class="details2 column center">
                  <div class="text1">充值返现（元）</div>
                  <div class="text2">{{vipList.vipDate.today_cash_back}}</div>
                </div>
                <div class="details2 column center">
                  <div class="text1">现金充值（元）</div>
                  <div class="text2">{{vipList.vipDate.today_cash_recharge}}</div>
                </div>
                <div class="details3 column center">
                  <div class="text1">今日消费（元）</div>
                  <div class="text2 red">{{vipList.vipDate.today_total_consume}}</div>
                </div>
                <div class="details3 column center">
                  <div class="text1">今日激活会员（人）</div>
                  <div class="text2 red">{{vipList.vipDate.today_activation_num}}</div>
                </div>
              </div>

              <div class="content" style="padding:0">
                <div class="details4 column center">
                  <div class="text1">会员充值总额（元）</div>
                  <div class="text2">{{vipList.vipDate.total_recharge}}</div>
                </div>
                <div class="details4 column center">
                  <div class="text1">会员充值余额（元）</div>
                  <div class="text2">{{vipList.vipDate.total_member_balance}}</div>
                </div>
                <div class="details4 column center">
                  <div class="text1">会员消费总额（元）</div>
                  <div class="text2">{{vipList.vipDate.total_consume}}</div>
                </div>
                <div class="details4 column center">
                  <div class="text1">会员总人数（人）</div>
                  <div class="text2">{{vipList.vipDate.total_member_num}}</div>
                </div>
              </div>
              <div class="head row" style="margin-top:20px;">
                <h5>会员消费总额</h5>
                <!-- <span style="margin-left:10px;">更新时间：{{getTime}}</span> -->
              </div>
              <div class="head2">
                <div class="row">
                  <div>
                    <el-date-picker
                      v-model="vipList.date"
                      type="daterange"
                      size="small"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions3"
                    ></el-date-picker>
                  </div>
                  <el-select
                    size="small"
                    v-model="vipList.type"
                    placeholder="交易方式"
                    style="margin-left:20px;"
                  >
                    <el-option
                      v-for="item in vipList.type2"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>

                <div style="margin-top:20px;">
                  <el-button size="small" @click="search" type="primary">搜索</el-button>
                  <el-button size="small" @click="clearSearch">重置</el-button>
                  <el-button size="small" @click="excel">订单导出</el-button>
                </div>
              </div>

              <div class="column" style=" padding: 20px 0px;position: relative">
                <!-- <div class="time"> {{value2}}</div> -->
                <div class="time" v-if="vipList.searchTotal">
                  <span v-if="vipList.date">
                    {{vipList.date[0]}} - {{
                    vipList.date[1]}}
                  </span>
                  <span v-else>全部</span>
                  充值金额
                  <span class="red">{{vipList.searchTotal.total_recharge }}元</span> 消费金额
                  <span class="red">{{vipList.searchTotal.total_consume}}元</span>
                </div>
                <!-- 表格 -->
                <div style="width: 100%">
                  <el-table v-if="vipList.form" :data="vipList.form.list" style="width: 100%">
                    <el-table-column align="center" prop="finishTime" label="日期" width="180"></el-table-column>
                    <el-table-column align="center" prop="userName" label="客户手机号"></el-table-column>
                    <el-table-column align="center" prop="payMoney" label="金额"></el-table-column>
                    <el-table-column align="center" label="交易方式">
                      <template slot-scope="scope">
                        <span v-if="scope.row.receiptType == 1">现金充值</span>
                        <span v-if="scope.row.receiptType == 2">线上充值</span>
                        <span v-if="scope.row.receiptType == 3 || scope.row.receiptType == 31">会员消费</span>
                        <span v-if="scope.row.receiptType == 4">买家自己充值</span>
                        <span v-if="scope.row.receiptType == 7">刷卡记账</span>
                        <span v-if="scope.row.receiptType == 5">支付宝记账充值</span>
                        <span v-if="scope.row.receiptType == 6">微信记账充值</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <div
                  v-if="vipList.form"
                  style="float:right;margin-top:10px;position:absolute;right:0px;bottom:-20px;"
                >
                  <el-pagination
                    @current-change="handleCurrentChange2"
                    :current-page="1"
                    :page-size="20"
                    layout="total, prev, pager, next, jumper"
                    :total="vipList.form.totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import {
  cashierStatisticsList,
  cashierListTotalNum,
  saleStatisticsList,
  saleListTotalNum
} from "../api";
import echarts from "echarts";
export default {
  data() {
    var vue = this;
    return {
      vipList: {
        vipDate: [],
        date: "",
        type: "",
        type2: [
          { name: "现金充值", value: 1 },
          { name: "线上充值", value: 2 },
          { name: "会员消费", value: 3 },
          { name: "标记充值", value: 4 }
        ],
        form: []
      },
      activeName: "first",
      checked: true, //控制交易趋势里的点击状态
      checked2: false, //控制交易趋势里的点击状态
      checked3: false, //控制交易趋势里的点击状态
      options: [
        //门店地址数组
      ],
      //   表格
      tableData: [],
      tableData2: [],
      shopList: [
        { storeName: "全部门店", shopStoreId: "" }
        //门店地址数组
      ],
      pickerOptions1: {
        shortcuts: [
          {
            text: "今日",
            value: "today",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            value: "week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            value: "month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90日",
            value: "quarter",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      timeTabs: "today",
      pickerOptions2: {
        disabledDate(time) {
          let timeOptionRange = vue.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 90 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() > timeOptionRange.getTime() + secondNum ||
              time.getTime() < timeOptionRange.getTime() - secondNum
            );
          }
        },
        onPick(time) {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vue.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vue.timeOptionRange = null;
          }
        }
      },
      pickerOptions5: {
        disabledDate(time) {
          if (!vue.value5 || vue.value5[0] == null)  return false;
          let chosedDate = new Date(vue.value5[0]);
          let startyear = chosedDate.getFullYear() - 1;
          let endYear = chosedDate.getFullYear() + 1;
          let endDate =
            endYear +
            "-" +
            (chosedDate.getMonth() + 1) +
            "-" +
            chosedDate.getDate();
          let startDate =
            startyear +
            "-" +
            (chosedDate.getMonth() + 1) +
            "-" +
            chosedDate.getDate();
          let _endDate = new Date(endDate);
          let _startDate = new Date(startDate);
          //即大于开始时间小于结束时间
          return (
            time.getTime() > _endDate.getTime() ||
            time.getTime() < _startDate.getTime()
          );
        },
        onPick(time) {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vue.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vue.timeOptionRange = null;
          }
        }
      },
      pickerOptions: {
        disabledDate(time) {
          let timeOptionRange = vue.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 7 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() > timeOptionRange.getTime() + secondNum ||
              time.getTime() < timeOptionRange.getTime() - secondNum
            );
          }
        },
        onPick(time) {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vue.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vue.timeOptionRange = null;
          }
        }
      },
      pickerOptions3: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      options2: [
        { name: "日" },
        { name: "周" },
        { name: "月" },
        { name: "季度" }
      ],
      value2: "日", //日默认
      value3: "", //日默认
      value4: "", //日默认
      value5: [new Date(), new Date()], //日默认
      value: "全部门店", //门店默认
      value1: "", //日期默认
      valueTwo2: "日", //日默认
      valueTwo3: "", //日默认
      valueTwo4: "", //日默认
      valueTwo5: "", //日默认
      valueTwo: "全部门店", //门店默认
      valueTwo1: "", //日期默认
      echartsArr: [], //统计表数组
      timeList: [], //统计表时间数组
      ShopStoreStatistic: "", //经营分析
      editList: [],
      id: "main",
      str: "",
      dar: "",
      str2: "",
      dar2: "",
      toDay: [], //今日数据
      getTime: "", //当前时间
      todayGoods: "",
      pageNumber: "",
      totalCount: 0,
      startDate: "",
      endDate: "",
      excelList: { pageNo: 1, row: 5 },
      cashierList: [], //收银员列表
      cashierTotalCount: 0, //收银员记录总页数
      saleTotalCount: 0, //销售员记录总页数
      saleList: [], //销售员列表
      selectJob: "销售员", //切换销售统计表
      jobList: [{ jobName: "销售员" }, { jobName: "收银员" }],
      dar5: ""
    };
  },

  watch: {
    echartsArr: function() {
      let main = document.getElementById("main");
      var myChart = echarts.init(main);
      myChart.clear();
      this.myChart();
      // if (this.echartsArr.length !== 0) {

      // } else {
      //   let main = document.getElementById("main");
      //   console.log(this.echartsArr, "添加统计图");
      //   var myChart = echarts.init(main);
      //   myChart.clear();
      // }
    },
    value: function() {
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      var id = this.value;
      var date = this.value1;
      if (!this.value1) {
        date = str;
      }
      if (this.value == "全部门店") {
        id = "";
      }
      console.log(this.value1, id);

      // this.MallOrder_findShopStoreStatistic(date, id);
      // let main = document.getElementById("main");
      // console.log(this.echartsArr, "添加统计图");
      // var myChart = echarts.init(main);
      // myChart.clear();
      // this.myChart();
    },
    timeTabs(value) {
      const end = new Date();
      const start = new Date();
      if (value == "today") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
        this.value5 = [start, end];
      }
      if (value == "week") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        this.value5 = [start, end];
      }
      if (value == "month") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
        this.value5 = [start, end];
      }
      if (value == "quarter") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
        this.value5 = [start, end];
      }
      this.dateChange()
    },
  },

  created() {
    //  console.log = function(){}
    var id = this.value;
    if (this.value == "全部门店") {
      id = "";
    }
    var myDate = new Date();
    myDate.getYear(); //获取当前年份(2位)
    var month = myDate.getMonth() + 1;
    let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
    var date = myDate.getDate();
    var hours = myDate.getHours();
    var minutes = myDate.getMinutes();
    var seconds = myDate.getSeconds();
    if (date < 10) {
      date = "0" + date;
    }
    if (month < 10) {
      month = "0" + month;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    // let newDay = myDate.getFullYear() + "-" + month + "-" + date
    // this.value5 = [newDay, newDay]
    // console.log(this.value5, "this.value5", newDay)
    this.getTime =
      myDate.getFullYear() +
      "-" +
      month +
      "-" +
      date +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;
    var endDate = myDate.getDate() - 6;
    console.log(endDate, 'endDate')
    var str2 = myDate.getFullYear() + "-" + month + "-" + date;
    this.str2 = str2
    this.dar2 = str2
    console.log(str, str2, "new");
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.MallOrder_findShopStoreStatistic2(str2, id, str);
    this.cartogram(str2, str, id, true);
    this.Shop_shopStores(); //门店列表
    this.request
      .post("qrcapi/MallOrder_findShopStoreStatistic", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        startDate: str, //筛选开始时间
        endDate: str //结束时间
      })
      .then(res => {
        console.log(res, "今日数据");
        if (res.code == 1) {
          this.toDay = res.data;
          console.log(this.toDay, 'this.toDay')
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });

    //会员统计数据
    this.request
      .post("qrcapi/ShopMember_getShopMemberData", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
      .then(res => {
        console.log(res, "会员统计数据");
        if (res.code == 1) {
          this.vipList.vipDate = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    //商品分析（分页）
    this.MallOrder_findMallOrderProductStatistic(str, "", str);
    this.ShopMember_getShopMemberOrderDataByDate();
    this.ShopMember_getShopMemberOrderPager();
    this.cashierStatisticsList(str, "", str);
    this.saleStatisticsList(str, "", str);
    this.getProductsStatistic(str, "", str);
  },

  mounted() {
    //添加统计图
    this.myChart();
  },

  methods: {
    //商品分析数据
    getProductsStatistic(startDate, shopStoreId, endDate) {
      this.request
        .post("qrcapi/MallOrder_getProductsStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: shopStoreId, //门店id
          startDate: startDate, //筛选开始时间
          endDate: endDate //结束时间
        })
        .then(res => {
          console.log(res, "统计并比较今日的 销售商品数量、金额");
          if (res.code == 1) {
            this.todayGoods = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //销售员分页跳转
    saleHandleCurrentChange(val) {
        var id = this.value;
      if (this.value == "全部门店") {
        id = "";
      }
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      console.log(str,"str", id, "id", this.dar, "this.dar", val)
      this.saleStatisticsList(this.dar5,id,str,val);
    },
    //收银员分页跳转
    cashierHandleCurrentChange(val) {
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      this.cashierStatisticsList(str, val);
    },
    //销售员销售统计
    saleStatisticsList(startDate, shopStoreId, endDate, pageNo) {
      saleStatisticsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopStoreId: shopStoreId, //门店id
        startDate: startDate, //筛选开始时间
        endDate: endDate, //结束时间
        pageNo: pageNo,
        row: 3
      }).then(res => {
        console.log(res, "销售员销售统计");
        this.saleList = res.data;
      });
      saleListTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopStoreId: shopStoreId, //门店id
        startDate: startDate, //筛选开始时间
        endDate: endDate, //结束时间
        pageNo: pageNo,
        row: 3
      }).then(res => {
        console.log(res, "销售员记录总页数");
        this.saleTotalCount = res.data.totalNum;
      });
    },
    //收银员销售统计
    cashierStatisticsList(startDate, shopStoreId, endDate, pageNo) {
      cashierStatisticsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopStoreId: shopStoreId, //门店id
        startDate: startDate, //筛选开始时间
        endDate: endDate, //结束时间
        pageNo: pageNo,
        row: 3
      }).then(res => {
        console.log(res, "收银员销售统计");
        this.cashierList = res.data;
      });
      cashierListTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopStoreId: shopStoreId, //门店id
        startDate: startDate, //筛选开始时间
        endDate: endDate, //结束时间
        pageNo: pageNo,
        row: 3
      }).then(res => {
        console.log(res, "收银员记录总页数");
        this.cashierTotalCount = res.data.totalNum;
      });
    },
    //订单导出
    excel() {
      var sessionId = this.userList.sessionId;
      var userId = this.userList.id;
      if (this.vipList.date) {
        var startTime = this.vipList.date[0];
        var endTime = this.vipList.date[1];
      } else {
        var startTime = "";
        var endTime = "";
      }

      var pageNumber = this.excelList.pageNo;
      var secondShopMemberOrderType = this.vipList.type;
      console.log(startTime, endTime, pageNumber, secondShopMemberOrderType);
      // window.location.href ="+qrcapi/ShopMember_exportExcelShopMemberOrder?stime="+1+"&etime="+2;
      window.open(
        this.url +
          "qrcapi/ShopMember_exportExcelShopMemberOrder?sessionId=" +
          sessionId +
          "&userId=" +
          userId +
          "&startTime=" +
          startTime +
          "&endTime=" +
          endTime +
          // "&pageNumber=" +
          // pageNumber +
          "&secondShopMemberOrderType=" +
          secondShopMemberOrderType
        // +
        // '&row = 5'
      );
      // this.request
      //   .post("qrcapi/ShopMember_exportExcelShopMemberOrder", {
      //     sessionId: this.userList.sessionId,
      //     userId: this.userList.id,
      //     startTime:  this.vipList.date[0],//订单开始时间
      //     endTime:  this.vipList.date[1], //订单结束时间
      //     pageNumber: this.excelList.pageNo, // 当前页码
      //     // row:this.excelList.row, // 每页记录数
      //     secondShopMemberOrderType: this.vipList.type //  付款类型  1.现金充值  2.线上充值   3.会员消费
      //   })
      //   .then(res => {
      //     if (res.code == 1) {
      //     } else if (res.code == 2) {
      //       this.$message.error(res.msg);
      //       this.$router.push("/");
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
    },
    //会员订单列表
    ShopMember_getShopMemberOrderPager(
      startTime,
      endTime,
      pageNumber,
      secondShopMemberOrderType
    ) {
      this.request
        .post("qrcapi/ShopMember_getShopMemberOrderPager", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startTime: startTime, //订单开始时间
          endTime: endTime, //订单结束时间
          pageNumber: pageNumber, // 当前页码
          pageSize: 20, // 每页记录数
          secondShopMemberOrderType: secondShopMemberOrderType //  付款类型  1.现金充值  2.线上充值   3.会员消费  4刷卡记账 5支付宝记账充值 6微信记账充值
        })
        .then(res => {
          console.log(res, "会员订单列表");
          if (res.code == 1) {
            this.vipList.form = res.data.pager;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //根据日期查询充值金额
    ShopMember_getShopMemberOrderDataByDate(startTime, endTime) {
      this.request
        .post("qrcapi/ShopMember_getShopMemberOrderDataByDate", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startTime: startTime, //订单开始时间
          endTime: endTime //订单结束时间
        })
        .then(res => {
          console.log(res, "根据日期查询充值金额");
          if (res.code == 1) {
            this.vipList.searchTotal = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //重置
    clearSearch() {
      this.vipList.date = "";
      this.vipList.type = "";
      this.ShopMember_getShopMemberOrderPager();
      this.ShopMember_getShopMemberOrderDataByDate();
    },
    //搜索
    search() {
      console.log(this.vipList.date);
      if (this.vipList.date) {
        this.ShopMember_getShopMemberOrderPager(
          this.vipList.date[0],
          this.vipList.date[1],
          1,
          this.vipList.type
        );
        this.ShopMember_getShopMemberOrderDataByDate(
          this.vipList.date[0],
          this.vipList.date[1]
        );
      } else {
        this.ShopMember_getShopMemberOrderPager("", "", 1, this.vipList.type);
        this.ShopMember_getShopMemberOrderDataByDate("", "");
      }
    },
    //商品分析（分页）
    MallOrder_findMallOrderProductStatistic(
      startDate,
      shopId,
      endDate,
      pageNumber
    ) {
      this.request
        .post("qrcapi/MallOrder_findMallOrderProductStatistic", {
          shopStoreId: shopId,
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startDate: startDate, //筛选开始时间
          endDate: endDate, //结束时间
          pageNumber: pageNumber, // 当前页码
          pageSize: 10 // 每页记录数
        })
        .then(res => {
          console.log(res, "商品分析（分页）");
          if (res.code == 1) {
            this.tableData = res.data.pager.list;
            this.totalCount = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 控制交易金额交易趋势方框
    tep1() {
      this.checked = !this.checked;
      console.log(1);
      if (!this.checked) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "交易金额") {
            this.echartsArr.splice(i, 1);
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.money,
          type: "line",
          smooth: true,
          name: "交易金额"
        });
      }
    },
    // 控制订单交易趋势方框
    tep3() {
      this.checked3 = !this.checked3;
      if (!this.checked3) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "增加订单数") {
            this.echartsArr.splice(i, 1);
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.orderNums,
          type: "line",
          smooth: true,
          name: "增加订单数"
        });
      }
      console.log(1);
    },
    // 控制会员交易趋势方框
    tep2: function() {
      this.checked2 = !this.checked2;
      if (!this.checked2) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "新增会员数") {
            console.log(this.echartsArr[i], "ii");
            this.echartsArr.splice(i, 1);
            console.log(this.echartsArr, "22");
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.newShopMemberNums,
          type: "line",
          smooth: true,
          name: "新增会员数"
        });
      }
      // this.echartsArr.splice(0,1)
      console.log(this.echartsArr);
    },
    //分页选择每页多少条
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageNumber = val;
      // debugger
      var id = this.valueTwo;
      if (this.valueTwo == "全部门店") {
        id = "";
      }
      var str = this.str2;
      var dar = this.dar2;
      console.log(str, dar);
      this.MallOrder_findMallOrderProductStatistic(str, id, dar, val);
      console.log(`当前页: ${val}`);
    },
    handleCurrentChange2(val) {
      if (this.vipList.date) {
        this.ShopMember_getShopMemberOrderPager(
          this.vipList.date[0],
          this.vipList.date[1],
          val,
          this.vipList.type
        );
      } else {
        this.ShopMember_getShopMemberOrderPager("", "", val, this.vipList.type);
      }

      this.excelList.pageNo = val;
    },
    //统计图
    cartogram(startDate, endDate, id, first) {
      this.request
        .post("qrcapi/MallOrder_getQueryDailyBargain", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: id, //门店id
          startDate: startDate, //筛选开始时间
          endDate: endDate //结束时间
        })
        .then(res => {
          console.log(res, "统计图");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            if (first) {
              this.echartsArr.push({
                data: res.data.money,
                type: "line",
                smooth: true,
                name: "交易金额"
              });
            } else {
              this.checked = true;
              this.checked2 = true;
              this.checked3 = true;
              if (this.checked && this.checked2 && this.checked3) {
                console.log("成功");
                this.echartsArr = [
                  {
                    data: res.data.money,
                    type: "line",
                    smooth: true,
                    name: "交易金额"
                  },
                  {
                    data: res.data.orderNums,
                    type: "line",
                    smooth: true,
                    name: "增加订单数"
                  },
                  {
                    data: res.data.newShopMemberNums,
                    type: "line",
                    smooth: true,
                    name: "新增会员数"
                  }
                ];
              }
            }
            this.timeList = res.data.dates;
            this.editList = res.data;
            let main = document.getElementById("main");
            var myChart = echarts.init(main);
            myChart.clear();
            this.myChart();
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //经营分析
    MallOrder_findShopStoreStatistic(startDate, shopStoreId) {
      this.request
        .post("qrcapi/MallOrder_findShopStoreStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: shopStoreId, //门店id
          startDate: startDate, //筛选开始时间
          endDate: startDate //结束时间
        })
        .then(res => {
          console.log(res, "经营分析1");
          this.ShopStoreStatistic = res.data;
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //经营分析
    MallOrder_findShopStoreStatistic2(startDate, shopStoreId, endDate) {
      this.request
        .post("qrcapi/MallOrder_findShopStoreStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: shopStoreId, //门店id
          startDate: startDate, //筛选开始时间
          endDate: endDate //结束时间
        })
        .then(res => {
          console.log(res, "经营分析2");
          this.ShopStoreStatistic = res.data;
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //门店列表
    Shop_shopStores(pageNo) {
      this.request
        .post("qrcapi/Shop_shopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: pageNo,
          row: 10
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            // console.log(res, "素有门店");
            // var totalMoney = 0;
            // for (let i in res.data) {
            //   totalMoney += Number(res.data[i].gainMoney);
            // }
            // this.totalMoney = totalMoney;
            for (let i in res.data.list) {
              this.shopList.push(res.data.list[i]);
            }
            console.log(this.shopList, "this.shopList");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //监听门店改变
    shopChange() {
      this.value1 = "";
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
      this.valueTwo3 = "";
      this.valueTwo4 = "";
      this.valueTwo5 = "";
      this.valueTwo1 = "";
      //  var id = this.value;
      // if (this.value == "全部门店") {
      //   id = "";
      // }
      // console.log(this.value, "门店改变");
      this.cartogram(this.str, this.dar, id);
    },
    dateChange2(e) {
      var id = this.valueTwo;
      if (this.valueTwo == "全部门店") {
        id = "";
      }
      var str = this.str2;
      var dar = this.dar2;
      // var d = new Date(2018, 6, 0);
      // console.log(d.getDate(), "每个月天数");
      if (e == "week") {
        if (this.valueTwo3) {
          str = this.valueTwo3[0];
          dar = this.valueTwo3[1];
        } else {
          str = "";
          dar = "";
        }
        this.startDate = str;
        this.endDate = dar;
        // this.cartogram(str, dar, id);
        this.MallOrder_findMallOrderProductStatistic(str, id, dar);
        this.getProductsStatistic(str, id, dar);
        console.log(str, dar);
      } else if (e == "date") {
        str = this.valueTwo1;
        dar = this.valueTwo1;
        this.MallOrder_findMallOrderProductStatistic(
          this.valueTwo1,
          id,
          this.valueTwo1
        );
        this.getProductsStatistic(str, id, dar);

        console.log(this.valueTwo1, "日日日");
      } else if (e == "month") {
        str = this.valueTwo4 + "-" + "1";
        dar = this.valueTwo4 + "-" + "31";
        this.startDate = str;
        this.endDate = dar;
        // this.cartogram(str, dar, id);
        this.MallOrder_findMallOrderProductStatistic(str, id, dar);
        this.getProductsStatistic(str, id, dar);
        console.log(str, dar, "month");
      } else if (e == "threeMonth") {
        if (this.valueTwo5) {
          str = this.valueTwo5[0] + "-" + "1";
          dar = this.valueTwo5[1] + "-" + "31";
        } else {
          str = "";
          dar = "";
        }

        this.startDate = str;
        this.endDate = dar;
        // this.cartogram(str, dar, id);
        this.MallOrder_findMallOrderProductStatistic(str, id, dar);
        this.getProductsStatistic(str, id, dar);
        console.log(str, dar, "threeMonth");
      }
      this.str2 = str;
      this.dar2 = dar;
    },
    //监听日期下拉框
    dateChange(e) {
      console.log(111)
      var id = this.value;
      if (this.value == "全部门店") {
        id = "";
      }
      var str = this.str;
      var dar = this.dar;
      var d = new Date(2018, 6, 0);
      console.log(d.getDate(), "每个月天数");

      if (this.value5) {
      console.log(this.value5, "this.value5")
        if (e !== 'threeMonth') {
          let month = this.value5[0].getMonth() + 1 <= 9 ? '0' + (this.value5[0].getMonth() + 1) : this.value5[0].getMonth() + 1
          let date = this.value5[0].getDate() <= 9 ? '0' + this.value5[0].getDate() : this.value5[0].getDate()
          str = this.value5[0].getFullYear() + '-' + month + '-' + date;
          let month1 = this.value5[1].getMonth() + 1 <= 9 ? '0' + (this.value5[1].getMonth() + 1) : this.value5[1].getMonth() + 1
          let date1 = this.value5[1].getDate() <= 9 ? '0' + this.value5[1].getDate() : this.value5[1].getDate()
          dar = this.value5[1].getFullYear() + '-' + month1 + '-' + date1;
        } else {
          str = this.value5[0]
          dar = this.value5[1]
        }
        // str = new Date(this.value5[0]).pattern("yyyy-MM-dd");
        // dar = new Date(this.value5[1]).pattern("yyyy-MM-dd");
        this.cartogram(str, dar, id);
        this.MallOrder_findShopStoreStatistic2(str, id, dar);
        this.saleStatisticsList(str, id, dar);
        this.cashierStatisticsList(str, id, dar);
        console.log(str, dar, "threeMonth");
        this.dar5 = str
      } else {
      }
    },
    myChart() {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate() + 1;
      let date = month + "-" + day;
      console.log(this.echartsArr, "this.echartsArr");
      // 统计图
      let main = document.getElementById("main");
      var myChart = echarts.init(main);
      myChart.setOption({
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: this.timeList
        },
        yAxis: {
          type: "value"
        },
        series: this.echartsArr
        // grid:{
        //   top:50,
        //   x:500,
        //   x2:555,
        //   y:222,
        // }
      });
    }
  }
};
</script>

<style scoped>
.first {
  padding: 30px;
  border-top: 1px solid #eee;
}
.head2 {
  box-sizing: border-box;
  padding: 30px 25px;
  background: #f8f8f8;
  width: 100%;
  margin-top: 20px;
}
.head {
  box-sizing: border-box;
  width: 100%;
  font-size: 12px;
  background: #f8f8f8;
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
}
.content {
  box-sizing: border-box;
  margin-top: 20px;
  width: 100%;
  background: #f8f8f8;
  display: flex;
  padding: 20px 40px;
}
.content2 {
  box-sizing: border-box;
  margin-top: 20px;
  width: 100%;
  display: flex;
}
.red {
  color: #ff5757;
}
.text1 {
  font-size: 12px;
}
.text2 {
  font-size: 20px;
  margin: 15px 0;
}
.text3 {
  font-size: 12px;
  color: #9f9f9f;
  margin-bottom: 10px;
}
.details {
  width: 25%;
  background: #f8f8f8;
}
.details2 {
  width: 270px;
  padding: 20px 0px;
  background: #f8f8f8;
}
.details3 {
  margin-left: 30px;
  width: 260px;
  padding: 20px 0px;
  background: #f8f8f8;
}
.details4 {
  width: 25%;
  padding: 20px 0px;
  background: #f8f8f8;
}
.details4:first-child {
  width: 270px;
  padding: 20px 0px;
  background: #f8f8f8;
}
.details2:first-child {
  border-right: 1px solid #e7e7e7;
}
.topPlate {
  background: #fff;
  width: 100% - 32px;
  border-radius: 10px;
  margin-top: 20px;
}
.topPlate-items {
  width: 25%;
}
.topPlate-content {
  margin-top: 28px;
  margin-left: 15px;
  width: 100%;
}
.time {
  font-size: 12px;
  margin-bottom: 20px;
}

.text3 {
  font-size: 12px;
}
.text4 {
  font-size: 22px;
  margin-top: 12px;
  margin-bottom: 10px;
}
.text5 {
  font-size: 13px;
  color: #858585;
  margin-left: 10px;
}
.margin-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.bottomTitle {
  background: #f8f8f8;
  padding: 10px;
}
.totot {
  width: 20px;
}
.tep {
  width: 130px;
  height: 100px;
  border: 1px solid #108ee9;
  border-radius: 10px;
  padding: 10px;
  margin-right: 10px;
  background: #e9f2ff;
}
.tep2 {
  width: 130px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
  margin-right: 10px;
}
.tepTitle {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.tepText {
  color: gray;
  justify-content: space-between;
  font-size: 13px;
}
.tepText:last-child {
  margin-top: 6px;
}
.tepPrice {
  margin: 10px 0;
}
.map {
  font-size: 14px;
  margin-top: 26px;
  color: gray;
}
.map:not(:first-child) {
  margin-left: 20px;
}
.circle {
  /* background: #108ee9; */
  background: #c23531;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.circle1 {
  background: #2f4554;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.circle2 {
  background: #61a0a8;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.mapText {
  margin-left: 5px;
}
h5 {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/information.vue